import './InputValidation-057236a4.css';

var classes = {"InputValidation":"prc-components-InputValidation-GjS0D","ValidationIcon":"prc-components-ValidationIcon-Kdbbr","ValidationText":"prc-components-ValidationText-jjsBp"};

export { classes as default };
